import React, { useState } from 'react';
import type { FAQQuestion } from '@/types/faq';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface FAQItemProps {
  question: FAQQuestion;
}

const FAQItem: React.FC<FAQItemProps> = ({ question }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-slate-900/60 rounded-xl border border-white/10 overflow-hidden">
      <button
        className="w-full px-8 py-6 flex justify-between items-center bg-transparent hover:bg-white/5"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3
          className="text-white text-lg font-medium text-left flex-1"
          dangerouslySetInnerHTML={{ __html: question.question }}
        />
        <div className="w-5 h-5 flex items-center justify-center">
          {isOpen ? (
            <ChevronUp className="w-4 h-4 text-gray-400" />
          ) : (
            <ChevronDown className="w-4 h-4 text-gray-400" />
          )}
        </div>
      </button>
      
      {isOpen && (
        <div className="px-8 py-6 border-t border-white/10">
          <div 
            className="text-white/70 text-lg leading-7 prose prose-invert max-w-none"
            dangerouslySetInnerHTML={{ __html: question.answer }}
          />
        </div>
      )}
    </div>
  );
};

export default FAQItem;